import { useState } from 'react'
import SelectBox from 'components/form/SelectBox'
import Button from 'components/form/Button'
import { batch, shallowEqual, useDispatch, useSelector } from 'react-redux'
import {
  reset,
  setHasLandingURL,
  setIndividual,
} from 'features/dashboard/operation/keywordLandingUrlEdit/keywordLandingUrlEditSlice'
import CheckBox from 'components/form/CheckBox'
import { exitEditable } from 'features/dashboard/table/keyword/keywordTableSlice'
import useKeywordLandingUrlEdit from 'features/dashboard/operation/keywordLandingUrlEdit/useKeywordLandingUrlEdit'

const KeywordLandingUrlEditTableHeader = () => {
  const dispatch = useDispatch()
  const { hasLandingURL, isIndividual, siteSetting } = useSelector(
    state => state.dashboard.operation.keywordLandingURL,
    shallowEqual
  )
  const [innerHasLandingURL, setInnerHasLandingURL] = useState(hasLandingURL)
  const [innerIsIndividual, setInnerIsIndividual] = useState(isIndividual)
  const modifyLandingURL = useKeywordLandingUrlEdit()
  const onApplyClick = () =>
    batch(() => {
      dispatch(setHasLandingURL(innerHasLandingURL))
      dispatch(setIndividual(innerIsIndividual))
    })

  return (
    <div className="set_head">
      <div className="f_left">
        <div className="single_wrap">
          <SelectBox
            noBlurOnDefault
            value={innerHasLandingURL}
            onValueChange={setInnerHasLandingURL}>
            <SelectBox.Item value={true}>설정</SelectBox.Item>
            <SelectBox.Item value={false}>미설정</SelectBox.Item>
          </SelectBox>
        </div>
        <div className="single_wrap">
          {innerHasLandingURL ? (
            <>
              <CheckBox
                label="모바일/PC 랜딩URL 개별 설정"
                checked={!!innerIsIndividual}
                disabled={siteSetting.isIndividual}
                onCheckedChange={isChecked =>
                  isChecked && setInnerIsIndividual(true)
                }
              />
              <CheckBox
                label="모바일/PC 랜딩URL 일괄 설정"
                checked={!innerIsIndividual}
                disabled={siteSetting.isIndividual}
                onCheckedChange={isChecked =>
                  isChecked && setInnerIsIndividual(false)
                }
              />
            </>
          ) : (
            <span className="box_checkinp">키워드 랜딩URL 미설정</span>
          )}
        </div>
        <div className="single_wrap">
          <Button
            line
            disabled={
              innerHasLandingURL === hasLandingURL &&
              innerIsIndividual === isIndividual
            }
            onClick={onApplyClick}>
            적용
          </Button>
        </div>
        <div className="btn_group">
          <div className="single_wrap">
            <Button
              line
              onClick={() => {
                batch(() => {
                  dispatch(exitEditable())
                  dispatch(reset())
                })
              }}>
              이전
            </Button>
          </div>
          <div className="single_wrap">
            <Button primary onClick={modifyLandingURL.save}>
              저장
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default KeywordLandingUrlEditTableHeader
